import React from "react";
import "./header.scss";
import ChainSelect from "../../components/chainSelect/ChainSelect";
import ProfileDropdown from "../../components/ProfileDropdown/ProfileDropdown";
import { FiMenu } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { otherDataAC } from "../../store/action-creators";
import { CgClose } from "react-icons/cg";
import { getBlockchainType } from "../../utils/services/auth";
import { ThemeChanger } from "../../components";

const Header: React.FC = () => {
  const dispatch = useDispatch();
  const store = useSelector((store: any) => store);
  const _otherData = bindActionCreators(otherDataAC, dispatch);

  return (
    <div className="header">
      <div className="header__logoBox">
        <div className="logo">
          <img src="/LighthouseLogo.svg" alt="" />
        </div>
      </div>
      <div className="header__chainBox">
        <ThemeChanger />
        {getBlockchainType() === "EVM" && (
          <div className="container">
            <ChainSelect theme="light" version={"short"} />
          </div>
        )}
      </div>

      <div className="header__infoBox ptr">
        <ProfileDropdown />
      </div>

      <div
        className="header__menuBox"
        onClick={() => {
          _otherData.setOtherData({
            sidebarClosed: !store?.otherData?.sidebarClosed,
          });
        }}
      >
        {store.otherData.sidebarClosed ? <FiMenu /> : <CgClose />}
      </div>
    </div>
  );
};

export default Header;
